<boels-store-finder-search></boels-store-finder-search>
<boels-store-finder-list-map [stores$]="stores$"></boels-store-finder-list-map>
